import { createSlice } from "@reduxjs/toolkit";
import { fetchBalanceSheet } from "./balanceSheetThunk";

const initialState = {
  balances: {},
  appliedFilters: null,
  loading: false,
  error: null,
  filters: {
    filterType: "Date Wise",
    fromDate: null,
    toDate: null,
  },
};

const balanceSheetSlice = createSlice({
  name: "balanceSheet",
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchBalanceSheet.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchBalanceSheet.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        state.balances = action.payload || {};
        state.appliedFilters = action.meta.arg?.filters || null;
      })
      .addCase(fetchBalanceSheet.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.payload?.message || action.payload || "Failed to fetch records";
      });
  },
});

export const { setFilters } = balanceSheetSlice.actions;
export default balanceSheetSlice.reducer;
